import React from "react";
import { CiLocationOn, CiMail, CiPhone } from "react-icons/ci"; // New Icons Imported
import { Outlet, Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function Nav2() {
  return (
    <>
      <nav className="navbar navbar-expand-lg modern-nav sticky-top">
        <div className="container">
          {/* Left Side - Email (Brand feel) */}
          <Link to="mailto:jawaliholidays@gmail.com" className="navbar-brand d-flex align-items-center gap-2">
            <span className="icon-circle">
              <CiMail className="icon-style" />
            </span>
            <span className="brand-text">jawaliholidays@gmail.com</span>
          </Link>

          {/* Toggler Button (Customized) */}
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#topNavbar"
            aria-controls="topNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Content */}
          <div className="collapse navbar-collapse" id="topNavbar">
            <ul className="navbar-nav ms-auto gap-3 gap-lg-4 align-items-start align-items-lg-center mt-3 mt-lg-0">
              
              {/* Phone Number */}
              <li className="nav-item">
                <a href="tel:+919828074121" className="nav-link-custom d-flex align-items-center gap-2">
                  <CiPhone className="icon-style" />
                  <span>+91 98280-74121</span>
                </a>
              </li>

              {/* Location */}
              <li className="nav-item">
                <span className="nav-link-custom d-flex align-items-center gap-2">
                  <CiLocationOn className="icon-style" />
                  <span>Sardarpura, Jodhpur</span>
                </span>
              </li>



            </ul>
          </div>
        </div>
      </nav>

      <Outlet />
    </>
  );
}